import '../../../scss/hotfood/components/hotfood-fable.scss'

import { Flex } from '@sainsburys-tech/fable'
import {
  Body1,
  Button,
  ButtonGroup,
  ButtonGroupSection,
  Display2,
  Grid,
  GridItem,
  Modal,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React from 'react'

import { AlertLevelEnum } from '../../enums/AlertLevelEnum'
import { IAlertModalProps } from '../../types/IAlertModalProps'
import { TemperatureAlertMessages } from '../../utils/TemperatureAlertMessages'

const TemperatureBoostAlertModal = (props: IAlertModalProps) => {
  const getMessageContent = (alertLevel: AlertLevelEnum | undefined) => {
    const message = TemperatureAlertMessages.find(
      (m) => m.alertLevel === alertLevel,
    )
    return (
      <>
        {message && (
          <Flex direction='column' alignItems='center' gap='md'>
            <Flex alignItems='center' as='h4' data-testid='modalTitle' gap='sm'>
              {alertLevel === AlertLevelEnum.Warning && (
                <span>
                  <AlertCircleFilled className='c-form-alert-icon-red' />
                </span>
              )}
              <Display2>{message.title}</Display2>
            </Flex>
            <div>
              <Body1>{message.instruction}</Body1>
            </div>
          </Flex>
        )}
      </>
    )
  }

  return (
    <>
      <Modal
        size='sm'
        onClose={() => props.handleClose()}
        isOpen={props.isOpen}
        testid='info-modal'
        className='c-production-temperature-boost-modal'
      >
        {getMessageContent(props.alertLevel)}

        <ButtonGroup>
          <ButtonGroupSection className='hotfood-full-width'>
            <Grid>
              <GridItem
                style={{ paddingTop: '24px' }}
                className='c-hotfood-modal-button-padding'
                colSpan={{
                  default: 12,
                  xs: 6,
                  sm: 6,
                  md: 6,
                  lg: 6,
                }}
              >
                <Button
                  className='c-hotfood-modal-button c-submit-modal-button hotfood-full-width'
                  onClick={() => props.handleClose()}
                  testid='modal-button'
                >
                  {props.alertLevel === AlertLevelEnum.Advisory &&
                    "I'll boost it"}
                  {props.alertLevel === AlertLevelEnum.Watch &&
                    "I'll boost it again"}
                  {props.alertLevel === AlertLevelEnum.Warning &&
                    "I'll dispose and report it"}
                </Button>
              </GridItem>
            </Grid>
          </ButtonGroupSection>
        </ButtonGroup>
      </Modal>
    </>
  )
}

export default TemperatureBoostAlertModal
